"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Box = _interopRequireDefault(require("../Box"));
var _Divider = _interopRequireDefault(require("../Divider"));
var _View = _interopRequireDefault(require("../View"));
var _MenuList = _interopRequireDefault(require("./MenuList"));
var _SelectDropdownErrorBoundary = require("./SelectDropdownErrorBoundary");
var _AddButton = require("./components/AddButton");
var _DeselectButton = require("./components/DeselectButton");
var _FavoritsButton = require("./components/FavoritsButton");
var _Input = _interopRequireDefault(require("./components/Input"));
var _SelectAllButton = require("./components/SelectAllButton");
var _constants = require("../Select/constants");
var _constants2 = require("./constants");
var _hooks = require("./hooks");
var _useMemoOptionsWithLimit = require("./hooks/useMemoOptionsWithLimit");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var SelectDropdownMenu = function SelectDropdownMenu(_ref) {
  var _ref$selectedOptions = _ref.selectedOptions,
    selectedOptions = _ref$selectedOptions === void 0 ? _constants2.EMPTY_SELECTED_OPTIONS : _ref$selectedOptions,
    filterOption = _ref.filterOption,
    rowHeight = _ref.rowHeight,
    groupHeight = _ref.groupHeight,
    sourceOptions = _ref.options,
    disabled = _ref.disabled,
    renderOption = _ref.renderOption,
    renderGroup = _ref.renderGroup,
    onChange = _ref.onChange,
    width = _ref.width,
    withFilter = _ref.withFilter,
    withSelectAll = _ref.withSelectAll,
    withDeselectButton = _ref.withDeselectButton,
    searchExp = _ref.searchExp,
    markSelectedOption = _ref.markSelectedOption,
    _ref$groupBy = _ref.groupBy,
    groupBy = _ref$groupBy === void 0 ? 'group' : _ref$groupBy,
    canDeselect = _ref.canDeselect,
    noResultsPlaceholder = _ref.noResultsPlaceholder,
    _ref$MenuListComponen = _ref.MenuListComponent,
    MenuListComponent = _ref$MenuListComponen === void 0 ? _MenuList["default"] : _ref$MenuListComponen,
    onAdd = _ref.onAdd,
    addOptionLabel = _ref.addOptionLabel,
    onCloseDropdown = _ref.onCloseDropdown,
    isOptionDisabled = _ref.isOptionDisabled,
    _ref$minOptionCountFo = _ref.minOptionCountForSearch,
    minOptionCountForSearch = _ref$minOptionCountFo === void 0 ? _constants2.MIN_OPTION_COUNT_FOR_FILTERING : _ref$minOptionCountFo,
    favorits = _ref.favorits,
    favoritsLabel = _ref.favoritsLabel,
    multiple = _ref.multiple,
    hideSelectedOption = _ref.hideSelectedOption,
    firstSelected = _ref.firstSelected,
    isServerSideInitScreen = _ref.isServerSideInitScreen,
    onSearch = _ref.onSearch,
    loading = _ref.loading,
    fetching = _ref.fetching,
    isServerSideMode = _ref.isServerSideMode,
    inputPlaceholder = _ref.inputPlaceholder,
    _ref$getOptionValue = _ref.getOptionValue,
    getOptionValue = _ref$getOptionValue === void 0 ? _constants2.defaultGetOptionValue : _ref$getOptionValue;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var focusableOptionsRef = (0, _react.useRef)([]);
  var selectedOptionsRef = (0, _react.useRef)([]);
  selectedOptionsRef.current = selectedOptions;
  var _useState3 = (0, _react.useState)(function () {
      if (selectedOptions.length) {
        return selectedOptions[0];
      }
      return null;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedOption = _useState4[0],
    setFocusedOption = _useState4[1];
  var filteredOptions = (0, _react.useMemo)(function () {
    return (filterOption ? filterOption(sourceOptions, {
      inputValue: inputValue
    }) : sourceOptions).filter(function (el) {
      return !!el;
    });
  }, [sourceOptions, inputValue]);
  var normalizedOptions = (0, _hooks.useMemoOptionsWithLimit)(filteredOptions);
  var limitOverflow = (0, _react.useMemo)(function () {
    return sourceOptions.length > _useMemoOptionsWithLimit.MAX_OPTIONS;
  }, [filteredOptions]);
  (0, _hooks.useEffectScrollControl)();
  var isOptionFocused = (0, _hooks.useIsOptionFocused)({
    focusedOption: focusedOption,
    getOptionValue: getOptionValue
  });
  var isOptionSelected = (0, _hooks.useIsOptionSelected)({
    selectedOptions: selectedOptions,
    getOptionValue: getOptionValue
  });
  var handleSelectOption = (0, _react.useCallback)(function (option) {
    var selected = isOptionSelected(option);
    if (!selected) {
      onChange(option ? [].concat(_toConsumableArray(selectedOptions), [option]) : selectedOptions);
    } else if (canDeselect) {
      var id = getOptionValue(option);
      onChange(selectedOptions.filter(function (opt) {
        return getOptionValue(opt) !== id;
      }));
    } else {
      onChange(selectedOptions);
    }
  }, [onChange, selectedOptions, isOptionSelected, canDeselect]);
  var toOption = (0, _hooks.useToOption)({
    isOptionDisabled: isOptionDisabled,
    isOptionFocused: isOptionFocused,
    isOptionSelected: isOptionSelected,
    onOptionHover: setFocusedOption,
    onOptionSelect: handleSelectOption,
    renderOption: renderOption,
    selectedOptions: selectedOptions,
    inputValue: inputValue
  });
  var isGroupFocused = (0, _hooks.useIsGroupFocused)({
    focusedOption: focusedOption
  });
  var toGroup = (0, _hooks.useToGroup)({
    isGroupFocused: isGroupFocused,
    onOptionHover: setFocusedOption,
    multiple: multiple,
    renderGroup: renderGroup,
    filteredOptions: normalizedOptions,
    groupBy: groupBy,
    selectedOptions: selectedOptions,
    onChange: onChange,
    getOptionValue: getOptionValue
  });
  var toSubtitle = (0, _hooks.useToSubtitle)();
  var initialSelectedOptions = (0, _react.useMemo)(function () {
    return selectedOptions;
  }, []);
  var renderedOptions = (0, _react.useMemo)(function () {
    var groups = {};
    var other = [];
    var _groupOrder = [];
    var result = [];
    var withoutOptions = normalizedOptions.filter(function (data) {
      return initialSelectedOptions.every(function (initialData) {
        return getOptionValue(initialData) !== getOptionValue(data);
      });
    });
    if (firstSelected) {
      result.push.apply(result, _toConsumableArray(initialSelectedOptions.filter(function (item) {
        return normalizedOptions.some(function (opt) {
          return getOptionValue(item) === getOptionValue(opt);
        });
      }).map(function (item, i) {
        return toOption(item, -(i + 2));
      })));
    }
    if (isServerSideInitScreen && withoutOptions.length) {
      result.push(toSubtitle(_objectSpread(_objectSpread({}, _constants.LATEST_HELPER_OPTION), {}, {
        withDivider: true
      })));
    }
    var displayedOptions = hideSelectedOption || firstSelected ? withoutOptions : normalizedOptions;
    displayedOptions.forEach(function (item, i) {
      var option = item.type === _constants2.TYPE_SUBTITLE ? toSubtitle(item) : toOption(item, i);
      var groupKey = typeof groupBy === 'function' ? groupBy(item) : item[groupBy];
      if (groupKey) {
        if (!groups.hasOwnProperty(groupKey)) {
          _groupOrder.push(groupKey);
          groups[groupKey] = {
            group: toGroup({
              groupKey: groupKey
            }, i),
            children: []
          };
        }
        groups[groupKey].children.push(option);
      } else {
        other.push(option);
      }
    });
    result.push.apply(result, _toConsumableArray(_groupOrder.reduce(function (acc, groupKey) {
      return [].concat(_toConsumableArray(acc), [groups[groupKey].group], _toConsumableArray(groups[groupKey].children));
    }, [])));
    result.push.apply(result, other);
    return result;
  }, [normalizedOptions, groupBy, toOption, toGroup, toSubtitle]);
  focusableOptionsRef.current = (0, _react.useMemo)(function () {
    return renderedOptions.filter(function (_ref2) {
      var type = _ref2.type,
        disabled = _ref2.disabled;
      return type === 'option' && !disabled;
    }).map(function (_ref3) {
      var data = _ref3.data;
      return data;
    });
  }, [renderedOptions]);
  var getNextFocusedOption = (0, _hooks.useNextFocusedOption)({
    options: focusableOptionsRef.current,
    focusedOption: focusedOption,
    getOptionValue: getOptionValue
  });
  var handleKeyboardControl = (0, _react.useCallback)(function (direction) {
    setFocusedOption(function (_focusedOpt) {
      return getNextFocusedOption(direction);
    });
  }, [setFocusedOption, getNextFocusedOption]);
  var handleSelectFocusedOption = (0, _react.useCallback)(function () {
    handleSelectOption(focusedOption);
  }, [handleSelectOption, focusedOption]);
  var handleKeyDown = (0, _hooks.useKeyActions)({
    disabled: disabled,
    onFocus: handleKeyboardControl,
    onSelectFocusedOption: handleSelectFocusedOption
  });
  _react["default"].useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      return document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
  _react["default"].useEffect(function () {
    if (selectedOptionsRef.current.length) {
      setFocusedOption(selectedOptionsRef.current[0]);
    } else if (focusableOptionsRef.current.length) {
      setFocusedOption(focusableOptionsRef.current[0]);
    }
  }, [normalizedOptions]);
  var focusableSelectedOptions = (0, _react.useMemo)(function () {
    var selectedOptionsIds = selectedOptions.map(getOptionValue);
    return focusableOptionsRef.current.filter(function (opt) {
      return selectedOptionsIds.includes(getOptionValue(opt));
    });
  }, [selectedOptions, focusableOptionsRef.current]);
  var focusableOptionsCount = focusableOptionsRef.current.length;
  var scrollToIndex = (0, _react.useMemo)(function () {
    if (inputValue && inputValue.length) {
      return 0;
    } else {
      return renderedOptions.findIndex(function (_ref4) {
        var data = _ref4.data;
        return data === focusedOption;
      });
    }
  }, [inputValue, renderedOptions, focusedOption]);
  var searchable = withFilter && (sourceOptions === null || sourceOptions === void 0 ? void 0 : sourceOptions.length) >= minOptionCountForSearch && (focusableOptionsCount || inputValue);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      width: "".concat(width, "px")
    },
    "data-cy": _constants2.dataCy,
    "data-testid": _constants2.dataCy,
    children: [searchable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box["default"], {
      m: 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
        value: inputValue,
        onChange: setInputValue,
        onSearch: onSearch,
        searchExp: searchExp,
        placeholder: inputPlaceholder
      })
    }) : null, onAdd ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddButton.AddButton, {
      disabled: loading,
      onCloseDropdown: onCloseDropdown,
      onAdd: onAdd,
      label: addOptionLabel
    }) : null, !(0, _isEmpty["default"])(favorits) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FavoritsButton.FavoritsButton, {
      label: favoritsLabel,
      disabled: loading,
      favorits: favorits,
      options: normalizedOptions,
      selectedOptions: selectedOptions,
      onChange: onChange,
      getOptionValue: getOptionValue
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_View["default"], {
      fetching: fetching,
      loading: loading,
      transparent: false,
      children: loading && !renderedOptions.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          height: '346px'
        }
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
        children: [withSelectAll && focusableOptionsCount ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectAllButton.SelectAllButton, {
          focusableSelectedOptions: focusableSelectedOptions,
          focusableOptions: focusableOptionsRef.current,
          selectedOptions: selectedOptions,
          onChange: onChange,
          limitOverflow: limitOverflow,
          getOptionValue: getOptionValue,
          count: filteredOptions.length
        }) : null, withDeselectButton && focusableOptionsCount ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeselectButton.DeselectButton, {
          renderedOptions: renderedOptions,
          onChange: onChange,
          rowHeight: rowHeight,
          multiple: multiple
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectDropdownErrorBoundary.SelectDropdownErrorBoundary, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuListComponent, {
            width: width,
            scrollToIndex: scrollToIndex,
            options: renderedOptions,
            rowHeight: rowHeight,
            groupHeight: groupHeight,
            markSelectedOption: markSelectedOption,
            noResultsPlaceholder: noResultsPlaceholder,
            withSearch: !!inputValue,
            isServerSideMode: isServerSideMode
          })
        })]
      })
    })]
  });
};
var _default = exports["default"] = SelectDropdownMenu;